import styled from 'styled-components';
import * as common from '../../_common';

export const Modal = styled(common.Modal)`
  width: 820px!important;
  max-width: calc(100% - 1rem);
`;
